import React from 'react';
import ReloadButton from '../../../../features/ReloadButton/ReloadButton';
import { ButtonPest } from '../../../../utils/Button';
import { InputFieldSearch, SelectOption, addOption } from '../../../../utils/InputField';
import { useServices } from '../ServicesProvider';

function PageHeaderLeftCol({ setServicesFilter, servicesFilter }) {
    const handleOnChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setServicesFilter((prev) => ({ ...prev, [name]: value }));
        }
    };

    return (
        <form className="page_header_left_col flex-1 flex items-center gap-x-3">
            <InputFieldSearch
                label="Search Products"
                name="searchValue"
                formData={servicesFilter || ''}
                onChange={handleOnChange}
                className="w-68"
            />
            <SelectOption
                placeholder="status"
                name="status"
                formData={servicesFilter || ''}
                onChange={handleOnChange}
                options={['active', 'inactive'].map((item) => addOption(item, item, item))}
                className="w-40"
            />
        </form>
    );
}

function ServiceListHeader() {
    const { handleReload, setAddServiceModal, servicesFilter, setServicesFilter } = useServices();

    return (
        <div className="app_page_header w-full mb-7 flex flex-row gap-2 justify-end items-center">
            <PageHeaderLeftCol
                setServicesFilter={setServicesFilter}
                servicesFilter={servicesFilter}
            />
            <div className="flex flex-row gap-2 items-center">
                <ButtonPest
                    btnType="button"
                    title="+ Add Service"
                    onClick={() => setAddServiceModal(true)}
                />
                <div>
                    <ReloadButton height="h-10" width="w-10" onClick={handleReload} />
                </div>
            </div>
        </div>
    );
}

export default ServiceListHeader;
